import { ReactElement } from 'react';
import { Snackbar, SnackbarContent, Slide } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TransitionProps } from '@mui/material/transitions';
import classNames from 'classnames';

// Styles
import 'components/Toast/toast.module.scss';
import './staticToast.module.scss';

// Store + Core
import { IStaticToastOptions } from 'core/models';
import CustomTooltip from 'components/Tooltip/Tooltip';

function slideTransition(props: TransitionProps & { children: ReactElement }) {
  return <Slide {...props} direction="up" />;
}

const StyledSnackbarContent = styled(SnackbarContent)({
  backgroundColor: '#00838f',
  borderRadius: 0,
  width: '100%',
  '& > div': {
    display: 'inline-flex',
    margin: '0 auto',
    width: '55%',
  },
  '& > div > span': {
    display: 'inline-flex',
    margin: '0 auto',
    width: '55%',
  },
});

interface IStaticToastProps {
  isOpen: boolean;
  toastOptions?: IStaticToastOptions[];
}

const StaticToast = (props: IStaticToastProps): ReactElement => {
  const { isOpen, toastOptions } = props;

  return (
    <Snackbar
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      sx={{ width: '100%' }}
      open={isOpen}
      slots={{ transition: slideTransition }}
    >
      <StyledSnackbarContent
        message={toastOptions.map((option: IStaticToastOptions) => {
          const element = (
            <div
              className={classNames('toast-content', 'static-toast-content', {
                'toast-content-centered': option?.centered,
                'toast-content-disabled': option?.disabled,
              })}
              onClick={!option?.disabled && option?.onClick}
              role="button"
            >
              {option?.icon || null}
              {option?.message}
            </div>
          );
          return option?.disabled && option?.disabledText ? (
            <CustomTooltip key={option?.toastType} tooltipText={option?.disabledText} aria-label={option?.disabledText}>
              {element}
            </CustomTooltip>
          ) : (
            <span>{element}</span>
          );
        })}
      />
    </Snackbar>
  );
};

export default StaticToast;
